module.exports = "<div ng-if=\"$ctrl.options\" \n     class=\"gridProductMovementStyle\" \n     ui-grid-selection\n     ui-grid=\"$ctrl.options\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/product-movements/product-movements.html
// module id = 72
// module chunks = 0